import api from './api'

export type MovimentoSaldoAntecipado = {
    Motivo: string
    Data: string | null
    Valor: number
    CdSaldo: number
    /** 0 = crédito; demais = débito (legado) */
    Operacao: number
    Limite: string | null
    Expirado: number
}

export type SaldoAntecipadoResponse = {
    disponivel: number
    extrato: MovimentoSaldoAntecipado[]
}

export async function getSaldoAntecipado(clienteHash?: string): Promise<SaldoAntecipadoResponse> {
    const res = await api.get('/clientes/saldo-antecipado', {
        headers: { clienteHash },
    })
    return res.data
}

export function isCreditoSaldo(operacao: number) {
    return operacao === 0
}

export function translateMotivoSaldo(motivo: string, t: (key: string) => string) {
    if (motivo === 'Servico') return t('Serviço')
    if (motivo === 'Venda Direta') return t('Venda Direta')
    if (motivo === 'Fatura') return t('Fatura')
    if (motivo === 'Expirou') return t('Expirou')
    return motivo
}
